import { render, staticRenderFns } from "./RedisInfo.vue?vue&type=template&id=2ed43541&"
import script from "./RedisInfo.vue?vue&type=script&lang=js&"
export * from "./RedisInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports